import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';

/**
 * Resolved related records for a vehicle group activity event, keyed by relation.
 */
export class VehicleGroupActivityEventHydration {
  link?: ActivityLinkHydration;
}
